import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./_Services/user/auth.guard";
import { ForbiddenComponent } from "./components/forbidden/forbidden/forbidden.component";
import { MainComponent } from "./layouts/main.component";
import { UnauthorizedComponent } from "./components/forbidden/unauthorized/unauthorized.component";
import { ConflictComponent } from "./components/forbidden/conflict/conflict.component";

const appRoutes: Routes = [
  { path: "", redirectTo: "callback", pathMatch: "full" },
  { path: "login", redirectTo: "callback", pathMatch: "full" },
  {
    path: "",
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "forbidden",
        component: ForbiddenComponent,
      },
      {
        path: "master/reset-cache",
        loadChildren: () =>
          import("./components/reset-cache/reset-cache.module").then(
            (m) => m.ResetCacheModule,
          ),
      },
      {
        path: "emailnotification",
        loadChildren: () =>
          import("./components/email-notification/edit-email-notification/edit-email-notification.module").then(
            (m) => m.EditEmailNotificationModule,
          ),
      },

      {
        path: "auditdashboard",
        loadChildren: () =>
          import("./components/Audit/audit-dashboard/auditdashboard.module").then(
            (m) => m.AuditDashboardModule,
          ),
      },

      {
        path: "factoryperformancedashboard",
        loadChildren: () =>
          import("./components/Audit/factory-performance-dashboard/factory-performance-dashboard.module").then(
            (m) => m.FactoryPerformanceDashboardModule,
          ),
      },
      {
        path: "predictive-analysis",
        loadChildren: () =>
          import("./components/Analytics/power-analytic/power-analytic.module").then(
            (m) => m.PowerAnalyticModule,
          ),
      },
      {
        path: "auditreport",
        loadChildren: () =>
          import("./components/Audit/audit-report/auditreport.module").then(
            (m) => m.AuditreportModule,
          ),
      },
      {
        path: "auditsummary",
        loadChildren: () =>
          import("./components/Audit/audit-summary/auditsummary.module").then(
            (m) => m.AuditsummaryModule,
          ),
      },
      {
        path: "auditcancel",
        loadChildren: () =>
          import("./components/Audit/cancel-audit/auditcancel.module").then(
            (m) => m.AuditcancelModule,
          ),
      },
      {
        path: "auditedit",
        loadChildren: () =>
          import("./components/Audit/edit-audit/auditedit.module").then(
            (m) => m.AuditeditModule,
          ),
      },
      {
        path: "calenderaudit",
        loadChildren: () =>
          import("./components/calendar-audit/calendar-audit.module").then(
            (m) => m.CalendarAuditModule,
          ),
      },
      {
        path: "inspsummary",
        loadChildren: () =>
          import("./components/booking/booking-summary/inspsummary.module").then(
            (m) => m.InspsummaryModule,
          ),
      },

      {
        path: "factoryperformancedashboard",
        loadChildren: () =>
          import("./components/Audit/factory-performance-dashboard/factory-performance-dashboard.module").then(
            (m) => m.FactoryPerformanceDashboardModule,
          ),
      },
      {
        path: "predictive-analysis",
        loadChildren: () =>
          import("./components/Analytics/power-analytic/power-analytic.module").then(
            (m) => m.PowerAnalyticModule,
          ),
      },
      {
        path: "auditreport",
        loadChildren: () =>
          import("./components/Audit/audit-report/auditreport.module").then(
            (m) => m.AuditreportModule,
          ),
      },
      {
        path: "auditsummary",
        loadChildren: () =>
          import("./components/Audit/audit-summary/auditsummary.module").then(
            (m) => m.AuditsummaryModule,
          ),
      },
      {
        path: "auditcancel",
        loadChildren: () =>
          import("./components/Audit/cancel-audit/auditcancel.module").then(
            (m) => m.AuditcancelModule,
          ),
      },
      {
        path: "auditedit",
        loadChildren: () =>
          import("./components/Audit/edit-audit/auditedit.module").then(
            (m) => m.AuditeditModule,
          ),
      },
      {
        path: "calenderaudit",
        loadChildren: () =>
          import("./components/calendar-audit/calendar-audit.module").then(
            (m) => m.CalendarAuditModule,
          ),
      },
      {
        path: "inspsummary",
        loadChildren: () =>
          import("./components/booking/booking-summary/inspsummary.module").then(
            (m) => m.InspsummaryModule,
          ),
      },

      {
        path: "predictive-analysis",
        loadChildren: () =>
          import("./components/Analytics/power-analytic/power-analytic.module").then(
            (m) => m.PowerAnalyticModule,
          ),
      },
      {
        path: "auditreport",
        loadChildren: () =>
          import("./components/Audit/audit-report/auditreport.module").then(
            (m) => m.AuditreportModule,
          ),
      },
      {
        path: "auditsummary",
        loadChildren: () =>
          import("./components/Audit/audit-summary/auditsummary.module").then(
            (m) => m.AuditsummaryModule,
          ),
      },
      {
        path: "auditcancel",
        loadChildren: () =>
          import("./components/Audit/cancel-audit/auditcancel.module").then(
            (m) => m.AuditcancelModule,
          ),
      },
      {
        path: "auditedit",
        loadChildren: () =>
          import("./components/Audit/edit-audit/auditedit.module").then(
            (m) => m.AuditeditModule,
          ),
      },
      {
        path: "calenderaudit",
        loadChildren: () =>
          import("./components/calendar-audit/calendar-audit.module").then(
            (m) => m.CalendarAuditModule,
          ),
      },
      {
        path: "inspsummary",
        loadChildren: () =>
          import("./components/booking/booking-summary/inspsummary.module").then(
            (m) => m.InspsummaryModule,
          ),
      },

      {
        path: "reportsummary",
        loadChildren: () =>
          import("./components/booking/report-summary/reportsummary.module").then(
            (m) => m.ReportsummaryModule,
          ),
      },

      {
        path: "bookingDetail",
        loadChildren: () =>
          import("./components/booking/booking-detail/bookingdetail.module").then(
            (m) => m.BookingDetailModule,
          ),
      },
      {
        path: "company",
        loadChildren: () =>
          import("./components/admin/company-detail/company-detail.module").then(
            (m) => m.CompanyDetailModule,
          ),
      },
      {
        path: "master",
        loadChildren: () =>
          import("./components/master/labtest-regulation-summary/labtest-regulation-summary.module").then(
            (m) => m.LabtestRegulationSummaryModule,
          ),
      },
      {
        path: "labTestRegulation",
        loadChildren: () =>
          import("./components/master/labtest-regulation-edit/labtest-regulation-edit.module").then(
            (m) => m.LabtestRegulationEditModule,
          ),
      },
      {
        path: "labTestStandardSummary",
        loadChildren: () =>
          import("./components/master/lab-test-standard-summary/lab-test-standard-summary.module").then(
            (m) => m.LabTestStandardSummaryModule,
          ),
      },
      {
        path: "labTestStandardEdit",
        loadChildren: () =>
          import("./components/master/lab-test-standard-edit/lab-test-standard-edit.module").then(
            (m) => m.LabTestStandardEditModule,
          ),
      },
      {
        path: "labTestDetailSummary",
        loadChildren: () =>
          import("./components/master/lab-test-detail-summary/lab-test-detail-summary.module").then(
            (m) => m.LabTestDetailSummaryModule,
          ),
      },
      {
        path: "labTestDetailEdit",
        loadChildren: () =>
          import("./components/master/lab-test-detail-edit/lab-test-detail-edit.module").then(
            (m) => m.LabTestDetailEditModule,
          ),
      },
      // {
      //   path: 'fullbridge',
      //   loadChildren: () => import('./components/fullbridge/fullbridge-summary/fullbridge-summary.module').then(m => m.FullbridgesummaryModule)
      // },

      {
        path: "inspcancel",
        loadChildren: () =>
          import("./components/booking/cancel-booking/inspcancel.module").then(
            (m) => m.InspcancelModule,
          ),
      },
      {
        path: "inspedit",
        loadChildren: () =>
          import("./components/booking/edit-booking/inspedit.module").then(
            (m) => m.InspeditModule,
          ),
      },
      {
        path: "inspcombine",
        loadChildren: () =>
          import("./components/booking/edit-combineproducts/inspcombine.module").then(
            (m) => m.InspcombineModule,
          ),
      },
      // {
      //   path: 'insppicking',
      //   loadChildren: () => import('./components/booking/edit-inspectionpicking/insppicking.module').then(m => m.InsppickingModule)
      //  },

      {
        path: "inspsplit",
        loadChildren: () =>
          import("./components/booking/split-booking/inspsplit.module").then(
            (m) => m.InspsplitModule,
          ),
      },
      // {
      //   path: 'exchangerate',
      //   loadChildren: () => import('./components/currency/exchange-rate/exchangerate.module').then(m => m.ExchangerateModule)
      // },
      // {
      //   path: 'ratematrix',
      //   loadChildren: () => import('./components/currency/rate-matrix/ratematrix.module').then(m => m.RatematrixModule)
      // },
      // {
      //   path: 'csconfigedit',
      //   loadChildren: () => import('./components/customer/cs-config-register/csconfigreg.module').then(m => m.CsconfigregModule)
      // },
      // {
      //   path: 'csconfigsearch',
      //   loadChildren: () => import('./components/customer/cs-config-summary/csconfigsearch.module').then(m => m.CsconfigsearchModule)
      // },
      // {
      //   path: 'cusbuyer',
      //   loadChildren: () => import('./components/customer/customer-buyer/customerbuyer.module').then(m => m.CustomerbuyerModule)
      // },
      {
        path: "cuscontactsearch",
        loadChildren: () =>
          import("./components/customer/customer-contact-summary/cuscontactsearch.module").then(
            (m) => m.CuscontactsearchModule,
          ),
      },
      // {
      //   path: 'compcontactsearch',
      //   loadChildren: () => import('./components/company/company-contact-summary/compcontactsearch.module').then(m => m.CompcontactsearchModule)
      // },
      {
        path: "cusdep",
        loadChildren: () =>
          import("./components/customer/customer-department/customerdep.module").then(
            (m) => m.CustomerdepModule,
          ),
      },
      {
        path: "cusproductsearch",
        loadChildren: () =>
          import("./components/customer/customer-product-summary/cusproductsearch.module").then(
            (m) => m.CusproductsearchModule,
          ),
      },
      {
        path: "cusproductsearch",
        loadChildren: () =>
          import("./components/customer/customer-product-summary/cusproductsearch.module").then(
            (m) => m.CusproductsearchModule,
          ),
      },
      {
        path: "dataaccess",
        loadChildren: () =>
          import("./components/data-access/data-access.module").then(
            (m) => m.DataAccessModule,
          ),
      },
      // {
      //   path: 'cusstylesearch',
      //   loadChildren: () => import('./components/customer/customer-style-summary/cusstylesearch.module').then(m => m.CusstylesearchModule)
      // },
      {
        path: "cusservicesearch",
        loadChildren: () =>
          import("./components/customer/customer-service-configuration-summary/cusservicesearch.module").then(
            (m) => m.CusservicesearchModule,
          ),
      },
      {
        path: "fabric-inspection",
        loadChildren: () =>
          import("./components/fabric-dashboard/fabric-inspection-dashboard.module").then(
            (m) => m.FabricInspectionDashboardModule,
          ),
      },
      // {
      //   path: 'compservicesearch',
      //   loadChildren: () => import('./components/company/company-service-configuration-summary/cmpservicesearch.module').then(m => m.CompservicesearchModule)
      // },
      // {
      //   path: 'cussearch',
      //   loadChildren: () => import('./components/customer/customer-summary/customersearch.module').then(m => m.CustomersearchModule)
      // },
      {
        path: "cusedit",
        loadChildren: () =>
          import("./components/customer/edit-customer/customeredit.module").then(
            (m) => m.CustomereditModule,
          ),
      },
      {
        path: "cusbrand",
        loadChildren: () =>
          import("./components/customer/edit-customer-brand/customerbrand.module").then(
            (m) => m.CustomerbrandModule,
          ),
      },
      // {
      //   path: 'cuscollection',
      //   loadChildren: () => import('./components/customer/customer-collection/customer-collection.module').then(m => m.CustomerCollectionModule)
      // },
      {
        path: "cuscontactedit",
        loadChildren: () =>
          import("./components/customer/edit-customer-contact/cuscontactedit.module").then(
            (m) => m.CuscontacteditModule,
          ),
      },
      {
        path: "cusproductedit",
        loadChildren: () =>
          import("./components/customer/edit-customer-product/cusproductedit.module").then(
            (m) => m.CusproducteditModule,
          ),
      },
      {
        path: "cusstyleedit",
        loadChildren: () =>
          import("./components/customer/edit-customer-style/cusstyleedit.module").then(
            (m) => m.CusstyleeditModule,
          ),
      },
      {
        path: "cusserviceedit",
        loadChildren: () =>
          import("./components/customer/edit-customer-service-configuration/cusserviceedit.module").then(
            (m) => m.CusserviceeditModule,
          ),
      },
      {
        path: "permissionmap",
        loadChildren: () =>
          import("./components/permission-map/permission-map/permission-map.module").then(
            (m) => m.PermissionMapModule,
          ),
      },
      {
        path: "apipermissions",
        loadChildren: () =>
          import("./components/apis/api-permission-map/apipermissionmap.module").then(
            (m) => m.ApiPermissionMapModule,
          ),
      },
      // {
      //   path: 'expenseclaim',
      //   loadChildren: () => import('./components/expense/expense-claim/expenseclaim.module').then(m => m.ExpenseclaimModule)
      // },
      // {
      //   path: 'expensesearch',
      //   loadChildren: () => import('./components/expense/expense-claim-list/expensesearch.module').then(m => m.ExpensesearchModule)
      // },
      {
        path: "staffedit",
        loadChildren: () =>
          import("./components/hr/edit-staff/staffedit.module").then(
            (m) => m.StaffeditModule,
          ),
      },
      // {
      //   path: 'holiday',
      //   loadChildren: () => import('./components/hr/holiday-master/holiday.module').then(m => m.HolidayModule)
      // },
      // {
      //   path: 'leaverequest',
      //   loadChildren: () => import('./components/hr/leave-request/leaverequest.module').then(m => m.LeaverequestModule)
      // },
      // {
      //   path: 'leavesearch',
      //   loadChildren: () => import('./components/hr/leave-summary/leavesearch.module').then(m => m.LeavesearchModule)
      // },
      // {
      //   path: 'officeconfig',
      //   loadChildren: () => import('./components/hr/office-control/officeconfig.module').then(m => m.OfficeconfigModule)
      // },
      // {
      //   path: 'staffsearch',
      //   loadChildren: () => import('./components/hr/staff-summary/staffsearch.module').then(m => m.StaffsearchModule)
      // },
      {
        path: "labedit",
        loadChildren: () =>
          import("./components/Lab/edit-lab/labedit.module").then(
            (m) => m.LabeditModule,
          ),
      },
      {
        path: "labsearch",
        loadChildren: () =>
          import("./components/Lab/lab-summary/labsearch.module").then(
            (m) => m.LabsearchModule,
          ),
      },
      {
        path: "lab-test-summary",
        loadChildren: () =>
          import("./components/Lab/lab-test-summary/lab-test-summary.module").then(
            (m) => m.LabTestSummaryModule,
          ),
      },
      {
        path: "city",
        loadChildren: () =>
          import("./components/location/city/city.module").then(
            (m) => m.CityModule,
          ),
      },
      {
        path: "country",
        loadChildren: () =>
          import("./components/location/country/country.module").then(
            (m) => m.CountryModule,
          ),
      },
      {
        path: "province",
        loadChildren: () =>
          import("./components/location/province/province.module").then(
            (m) => m.ProvinceModule,
          ),
      },
      {
        path: "county",
        loadChildren: () =>
          import("./components/location/county/county.module").then(
            (m) => m.CountyModule,
          ),
      },
      {
        path: "town",
        loadChildren: () =>
          import("./components/location/town/town.module").then(
            (m) => m.TownModule,
          ),
      },
      {
        path: "office",
        loadChildren: () =>
          import("./components/office/office.module").then(
            (m) => m.OfficeModule,
          ),
      },
      {
        path: "poedit",
        loadChildren: () =>
          import("./components/purchaseorder/edit-purchaseorder/poedit.module").then(
            (m) => m.PoeditModule,
          ),
      },
      {
        path: "qc-availability",
        loadChildren: () =>
          import("./components/qcavailability/edit-qcavailability/qcavailabilityedit.module").then(
            (m) => m.QCAvailabilityModule,
          ),
      },
      {
        path: "posearch",
        loadChildren: () =>
          import("./components/purchaseorder/purchaseorder-summary/posearch.module").then(
            (m) => m.PosearchModule,
          ),
      },
      {
        path: "poupload",
        loadChildren: () =>
          import("./components/purchaseorder/upload-purchaseorder/poupload.module").then(
            (m) => m.PouploadModule,
          ),
      },
      {
        path: "useredit",
        loadChildren: () =>
          import("./components/user-account/edit-user-account/useredit.module").then(
            (m) => m.UsereditModule,
          ),
      },
      {
        path: "usersearch",
        loadChildren: () =>
          import("./components/user-account/user-account-summary/usersearch.module").then(
            (m) => m.UsersearchModule,
          ),
      },
      {
        path: "rolerights",
        loadChildren: () =>
          import("./components/user-account/role-right-configuration/roleright.module").then(
            (m) => m.RolerightModule,
          ),
      },
      {
        path: "supplieredit",
        loadChildren: () =>
          import("./components/supplier/edit-supplier/supplieredit.module").then(
            (m) => m.SuppliereditModule,
          ),
      },
      {
        path: "invoice",
        loadChildren: () =>
          import("./components/invoice-summary/invoice-summary.module").then(
            (m) => m.InvoiceSummaryComponentModule,
          ),
      },
      {
        path: "suppliersearch",
        loadChildren: () =>
          import("./components/supplier/supplier-summary/suppliersearch.module").then(
            (m) => m.SuppliersearchModule,
          ),
      },
      {
        path: "quotation-summary",
        loadChildren: () =>
          import("./components/quotation/quotation-summary-component.module").then(
            (m) => m.QuotationSummaryModule,
          ),
      },
      // {
      //   path: "supplier",
      //   loadChildren: () =>
      //     import("./components/supplier-list/supplier-list.module").then(
      //       (m) => m.SupplierListModule
      //     ),
      // },
      //{
      //  path: 'supplierlite',
      //  loadChildren: () => import('./components/supplier/edit-supplier-lite/supplierlite.module').then(m => m.SupplierliteModule)
      //},

      // {
      //   path: 'cuscheckpointedit',
      //   loadChildren: () => import('./components/customer/edit-customer-checkpoint/edit-customer-checkpoint.module').then(m => m.EditCustomerCheckPointModule)
      // },
      // {
      //   path: 'cuscomplaintedit',
      //   loadChildren: () => import('./components/customer/edit-customer-complaint/edit-customer-complaint.module').then(m => m.EditCustomerComplaintModule)
      // },
      // {
      //   path: 'cuscomplaintsummary',
      //   loadChildren: () => import('./components/customer/customer-complaint-summary/customer-complaint-summary.module').then(m => m.CustomerComplaintSummaryModule)
      // },
      {
        path: "changepassword",
        loadChildren: () =>
          import("./components/change-password/changepassword.module").then(
            (m) => m.ChangepasswordModule,
          ),
      },

      // {
      //   path: 'intdashboard',
      //   loadChildren: () => import('./components/dashboards/internal/dashboard/intdashboard.module').then(m => m.IntdashboardModule)
      // },
      {
        path: "schedule",
        loadChildren: () =>
          import("./components/Schedule/schedule.module").then(
            (m) => m.ScheduleModule,
          ),
      },
      {
        path: "report",
        loadChildren: () =>
          import("./components/reports/reports.module").then(
            (m) => m.ReportModule,
          ),
      },
      // {
      //   path: 'inspectioncertificateedit',
      //   loadChildren: () => import('./components/inspection-certificate/edit-inspectioncertificate/edit-inspectioncertificate.module').then(m => m.EditInspectioncertificateModule)
      // },
      // {
      //   path: 'inspectioncertificatesearch',
      //   loadChildren: () => import('./components/inspection-certificate/inspectioncertificate-summary/inspectioncertificate-summary.module').then(m => m.InspectioncertificateSummaryModule)
      // },
      // {
      //   path: 'inspectioncertificatepending',
      //   loadChildren: () => import('./components/inspection-certificate/pending-inspectioncertificate/pending-inspectioncertificate.module').then(m => m.PendingInspectioncertificateModule)
      // },
      {
        path: "cusdashboard",
        loadChildren: () =>
          import("./components/dashboards/customer/cusdashboard/cusdashboard.module").then(
            (m) => m.CusdashboardModule,
          ),
      },
      {
        path: "audcusreport",
        loadChildren: () =>
          import("./components/Audit/audit-cus-report/audit-cus-report.module").then(
            (m) => m.AuditCusReportModule,
          ),
      },
      // {
      //   path: 'dfcustomerconfig',
      //   loadChildren: () => import('./components/dynamicfields/editdfcustomerconfiguration/editdfcustomerconfiguration.module').then(m => m.DFCustomerConfigurationModule)
      // },
      // {
      //   path: 'dfcustomerconfigsummary',
      //   loadChildren: () => import('./components/dynamicfields/dfcustomerconfigsummary/dfcustomerconfigsummary.module').then(m => m.DFCustomerConfigSummaryModule)
      // },
      // {
      //   path: 'userconfigcustomer',
      //   loadChildren: () => import('./components/user-account/user-config/userconfig.module').then(m => m.UserConfigModule)
      // },
      // {
      //   path: 'kpi',
      //   loadChildren: () => import('./components/kpi/kpi.module').then(m => m.kpiModule)
      // },
      // {
      //   path: 'pricecardsummary',
      //   loadChildren: () => import('./components/customer/customer-price-card-summary/customer-price-card-summary.module').then(m => m.CustomerPriceCardSummaryModule)
      // },
      // {
      //   path: 'pricecardedit',
      //   loadChildren: () => import('./components/customer/edit-customer-price-card/edit-customer-price-card.module').then(m => m.EditCustomerPriceCardModule)
      // },
      {
        path: "customkpi",
        loadChildren: () =>
          import("./components/kpi/custom-kpi/custom-kpi.module").then(
            (m) => m.CustomKpiModule,
          ),
      },
      {
        path: "qcavailability",
        loadChildren: () =>
          import("./components/Schedule/schedule.module").then(
            (m) => m.ScheduleModule,
          ),
      },
      {
        path: "qc-availability",
        loadChildren: () =>
          import("./components/qcavailability/qc-availabilitySummary/qc-availability-summary.module").then(
            (m) => m.QCAvailabilitySummaryModule,
          ),
      },
      // {
      //   path: 'travelmatrix',
      //   loadChildren: () => import('./components/invoice/travel-matrix/travel-matrix.module').then(m => m.TravelMatrixModule)
      // },
      {
        path: "qcdashboard",
        loadChildren: () =>
          import("./components/dashboards/qc/qcdashboard/qcdashboard.module").then(
            (m) => m.QcdashboardModule,
          ),
      },
      {
        path: "subscribe",
        loadChildren: () =>
          import("./components/subscription/subscribe-user/subscribeuser.module").then(
            (m) => m.SubscribeUserModule,
          ),
      },

      // {
      //   path: 'mandaydashboard',
      //   loadChildren: () => import('./components/statistics/manday-dashboard/manday-dashboard.module').then(m => m.MandayDashboardModule)
      // },
      {
        path: "mysubscription",
        loadChildren: () =>
          import("./components/subscription/my-subscription/mysubscription.module").then(
            (m) => m.MySubscriptionModule,
          ),
      },
      // {
      //   path: 'tcfsummary',
      //   loadChildren: () => import('./components/tcfdata/tcf-summary/tcf-summary.module').then(m => m.TCFSummaryModule)
      // },
      // {
      //   path: 'tcfdetail',
      //   loadChildren: () => import('./components/tcfdata/tcf-detail/tcf-detail.module').then(m => m.TCFDetailModule)
      // },
      // {
      //   path: 'tcfdocument',
      //   loadChildren: () => import('./components/tcfdata/tcf-document/tcf-document.module').then(m => m.TCFDocumentModule)
      // },
      // {
      //   path: 'tcfdashboard',
      //   loadChildren: () => import('./components/tcfdata/tcf-dashboard/tcf-dashboard.module').then(m => m.TCFDashboardModule)
      // },
      // {
      //   path: 'utilizationdashboard',
      //   loadChildren: () => import('./components/statistics/manday-utilization-dashboard/manday-utilization-dashboard.module').then(m => m.MandayUtilizationDashboardModule)
      // },
      // {
      //   path: 'invoicesummary',
      //   loadChildren: () => import('./components/invoice/invoice-summary/invoice-summary.module').then(m => m.InvoiceSummaryModule)
      // },
      // {
      //   path: 'invoicestatus',
      //   loadChildren: () => import('./components/invoice/invoice-status/invoice-status.module').then(m => m.InvoiceStatusModule)
      // },
      // {
      //   path: 'editinvoice',
      //   loadChildren: () => import('./components/invoice/edit-invoice/edit-invoice.module').then(m => m.EditInvoiceModule)
      // },
      // {
      //   path: 'invoicegenerate',
      //   loadChildren: () => import('./components/invoice/invoice-generate/invoice-generate.module').then(m => m.InvoiceGenerateModule)
      // },
      {
        path: "userprofile",
        loadChildren: () =>
          import("./components/user-account/user-profile/userprofile.module").then(
            (m) => m.UserProfileModule,
          ),
      },
      {
        path: "apilist",
        loadChildren: () =>
          import("./components/api-list/api-list.module").then(
            (m) => m.ApiListModule,
          ),
      },
      // {
      //   path: '#',
      //   loadChildren: () => import('./components/login/authentication-navigation/authentication-navigation.module').then(m => m.AuthenticationNavigationModule)
      // },
      // {
      //   path: ':error/:id',
      //   component: ErrorComponent
      // },
      // {
      //   path: 'forbidden',
      //   component: ForbiddenComponent
      // },
      // {
      //   path: '',
      //   loadChildren: () => import('./components/login/authentication-navigation/authentication-navigation.module').then(m => m.AuthenticationNavigationModule)
      // },
      // {
      //   path: 'invoicebanksummary',
      //   loadChildren: () => import('./components/invoice/invoice-bank/invoice-bank.module').then(m => m.InvoiceBankModule)
      // },
      // {
      //   path: 'invoicebankedit',
      //   loadChildren: () => import('./components/invoice/edit-invoice-bank/edit-invoice-bank.module').then(m => m.EditInvoiceBankModule)
      // },
      // {
      //   path: 'extrafeesedit',
      //   loadChildren: () => import('./components/invoice/edit-extra-fees/edit-extra-fees.module').then(m => m.EditExtraFeesModule)
      // },
      // {
      //   path: 'extrafeessummary',
      //   loadChildren: () => import('./components/invoice/extra-fees-summary/extra-fees-summary.module').then(m => m.ExtraFeesSummaryModule)
      // },
      // {
      //   path: 'qcblock',
      //   loadChildren: () => import('./components/Schedule/schedule.module').then(m => m.ScheduleModule)
      // },
      // {
      //   path: 'summary',
      //   loadChildren: () => import('./components/Schedule/schedule.module').then(m => m.ScheduleModule)
      // },
      // {
      //   path: 'supdashboard',
      //   loadChildren: () => import('./components/dashboards/supplierfactory/sup-fact-dashboard/sup-fact-dashboard.module').then(m => m.SupFactDashboardModule)
      // },
      // {
      //   path: 'email',
      //   loadChildren: () => import('./components/email-send/edit-email-subject/edit-email-subject.module').then(m => m.EditEmailSubjectModule)
      // },
      // {
      //   path: 'emailsub',
      //   loadChildren: () => import('./components/email-send/email-subject-summary/email-subject-summary.module').then(m => m.EmailSubjectSummaryModule)
      // },
      // {
      //   path: 'managementdashboard',
      //   loadChildren: () => import('./components/dashboards/management/managementdashboard/managementdashboard.module').then(m => m.ManagementdashboardModule)
      // },
      // {
      //   path: 'quantitativedashboard',
      //   loadChildren: () => import('./components/statistics/quantitativedashboard/quantitativedashboard/quantitativedashboard.module').then(m => m.QuantitativedashboardModule)
      // },
      {
        path: "defect",
        loadChildren: () =>
          import("./components/statistics/defect-dashboard/defect-dashboard.module").then(
            (m) => m.DefectDashboardModule,
          ),
      },
      // {
      //   path: 'emailconfig',
      //   loadChildren: () => import('./components/email-send/edit-email-configuration/edit-email-configuration.module').then(m => m.EditEmailConfigurationModule)
      // },
      // {
      //   path: 'econfig',
      //   loadChildren: () => import('./components/email-send/email-configuration-summary/email-configuration-summary.module').then(m => m.EmailConfigurationSummaryModule)
      // },
      {
        path: "reject",
        loadChildren: () =>
          import("./components/statistics/reject/rejectdashboard/rejectdashboard.module").then(
            (m) => m.RejectdashboardModule,
          ),
      },
      // {
      //   path: 'esend',
      //   loadChildren: () => import('./components/email-send/email-send-summary/email-send-summary.module').then(m => m.EmailSendSummaryModule)
      // },
      // {
      //   path: 'emailsend',
      //   loadChildren: () => import('./components/email-send/edit-email-send/edit-email-send.module').then(m => m.EditEmailSendModule)
      // },
      // {
      //   path: 'finance',
      //   loadChildren: () => import('./components/statistics/finance-dashboard/finance-dashboard/finance-dashboard.module').then(m => m.FinanceDashboardModule)
      // },
      // {
      //   path: 'cs',
      //   loadChildren: () => import('./components/dashboards/csdashboard/csdashboard.module').then(m => m.CsdashboardModule)
      // },
      {
        path: "userguide",
        loadChildren: () =>
          import("./components/user-guide/user-guide.module").then(
            (m) => m.UserGuideModule,
          ),
      },
      {
        path: "customerdecision",
        loadChildren: () =>
          import("./components/booking/customer-decision/inspcustomerdecision.module").then(
            (m) => m.CustomerDecisionModule,
          ),
      },
      {
        path: "calender",
        loadChildren: () =>
          import("./components/calender/calender.module").then(
            (m) => m.CalenderModule,
          ),
      },
      // {
      //   path: 'calender-demo',
      //  loadChildren: () => import('./components/calender-demo/calenderdemo.module').then(m => m.CalenderDemoModule)
      // },
      {
        path: "factorydashboard",
        loadChildren: () =>
          import("./components/statistics/factory-dashboard/factory-dashboard.module").then(
            (m) => m.FactoryDashboardModule,
          ),
      },
      {
        path: "qcdashboard",
        loadChildren: () =>
          import("./components/statistics/inspection-dashboard/inspection-dashboard.module").then(
            (m) => m.InspectionDashboardModule,
          ),
      },
      {
        path: "riskdashboard",
        loadChildren: () =>
          import("./components/statistics/risk-dashboard/risk-dashboard.module").then(
            (m) => m.RiskDashboardModule,
          ),
      },
      {
        path: "productdashboard",
        loadChildren: () =>
          import("./components/statistics/product-dashboard/product-dashboard.module").then(
            (m) => m.ProductDashboardModule,
          ),
      },
      {
        path: "tenantedit",
        loadChildren: () =>
          import("./components/tenants/edit-tenant/tenantedit.module").then(
            (m) => m.TenantEditModule,
          ),
      },
      {
        path: "subscriptionedit",
        loadChildren: () =>
          import("./components/subscription/edit-subscription/subscriptionedit.module").then(
            (m) => m.SubscriptionEditModule,
          ),
      },
      // {
      //   path: 'compedit',
      //   loadChildren: () => import('./components/company/edit-company/companyedit.module').then(m => m.CompanyEditModule)
      // },
      {
        path: "featureedit",
        loadChildren: () =>
          import("./components/feature/edit-feature/edit-feature/featureedit.module").then(
            (m) => m.FeatureEditModule,
          ),
      },
      {
        path: "apiedit",
        loadChildren: () =>
          import("./components/apis/edit-apis/edit-apis.module").then(
            (m) => m.EditApisModule,
          ),
      },
      {
        path: "rightedit",
        loadChildren: () =>
          import("./components/right/edit-right/edit-right.module").then(
            (m) => m.EditRightModule,
          ),
      },
      {
        path: "subscription",
        loadChildren: () =>
          import("./components/subscription/subscription-list/subscriptionlist.module").then(
            (m) => m.SubscriptionListModule,
          ),
      },
      {
        path: "tenantsearch",
        loadChildren: () =>
          import("./components/tenants/tenant-list/tenantlist.module").then(
            (m) => m.TenantListModule,
          ),
      },
      {
        path: "rightsearch",
        loadChildren: () =>
          import("./components/right/right-list/rightlist.module").then(
            (m) => m.RightListModule,
          ),
      },
      {
        path: "fbreportsync",
        loadChildren: () =>
          import("./components/fb-report-sync/fb-report-sync.module").then(
            (m) => m.FbReportSyncNewModule,
          ),
      },
      {
        path: "permissionfeatureedit",
        loadChildren: () =>
          import("./components/permission-feature/edit-permission-feature/permissionedit.module").then(
            (m) => m.PermissionFeatureEditModule,
          ),
      },
      {
        path: "permissionfeaturesearch",
        loadChildren: () =>
          import("./components/permission-feature/permissionfeature-list/permissionfeaturelist.module").then(
            (m) => m.PermissionFeatureListModule,
          ),
      },
      // {
      //   path: 'compbrand',
      //  loadChildren: () => import('./components/company/edit-company-brand/companybrand.module').then(m => m.CompanybrandModule)
      // },
      {
        path: "organization",
        loadChildren: () =>
          import("./components/company/organization-info/organizationinfo.module").then(
            (m) => m.OrganizationinfoModule,
          ),
      },
      {
        path: "product",
        loadChildren: () =>
          import("./components/product-management/product/product.module").then(
            (m) => m.ProductModule,
          ),
      },
      {
        path: "pim",
        loadChildren: () =>
          import("./components/material-management/material-management/material-management.module").then(
            (m) => m.MaterialManagementModule,
          ),
      },
      // {
      //   path:'compdept',
      //   //loadChildren: () => import('src/app/components/company/company-department/').then(m => m.CompanyDepartmentModule)
      //   loadChildren: () => import('/components/company/company-department/company-department.module').then(m => m.CompanyDepartmentModule)
      // },
      {
        path: "feature",
        loadChildren: () =>
          import("./components/feature/feature-list/feature-list/featurelist.module").then(
            (m) => m.FeatureListModule,
          ),
      },
      {
        path: "apiconfigure",
        loadChildren: () =>
          import("./components/apis/apis-list/apilist.module").then(
            (m) => m.ApisListModule,
          ),
      },
      {
        path: "roleedit",
        loadChildren: () =>
          import("./components/role/edit-role/roleedit.module").then(
            (m) => m.RoleEditModule,
          ),
      },
      {
        path: "rolesearch",
        loadChildren: () =>
          import("./components/role/role-list/rolelist.module").then(
            (m) => m.RoleListModule,
          ),
      },
      {
        path: "tenantdashboard",
        loadChildren: () =>
          import("./components/dashboards/customer/Tenant/tenantdashboard/tenantdashboard.module").then(
            (m) => m.TenantdashboardModule,
          ),
      },
      {
        path: "tenantdemodashboard",
        loadChildren: () =>
          import("./components/dashboards/customer/tenant-demo/tenant-demo.module").then(
            (m) => m.TenantDemoModule,
          ),
      },
      {
        path: "import",
        loadChildren: () =>
          import("./components/import-file/importfile.module").then(
            (m) => m.ImportFileModule,
          ),
      },
      {
        path: "tenantdashboard/dashboard",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./components/dashboards/customer/Tenant/tenantdashboard/tenantdashboard.module").then(
            (m) => m.TenantdashboardModule,
          ),
      },
      {
        path: "vendorlandingdashboard",
        loadChildren: () =>
          import("./components/supplier/vendor-landing-dashboard/vendor-landing-dashboard.module").then(
            (m) => m.VendorLandingDashboardModule,
          ),
      },
      {
        path: "userDashBoard",
        loadChildren: () =>
          import("./components/dashboards/user-dashboard/user-dashboard.module").then(
            (m) => m.UserDashboardModule,
          ),
      },
      // VendorViewModule
      {
        path: "view-vendor",
        loadChildren: () =>
          import("./components/supplier/view-vendor/view-vendor.module").then(
            (m) => m.ViewVendorModule,
          ),
      },
      {
        path: "vendor",
        loadChildren: () =>
          import("./components/vendor-invitation/vendor-invitation/vendor-invitation.module").then(
            (m) => m.VendorInvitationModule,
          ),
      },
      {
        path: "qmarkdashboard",
        loadChildren: () =>
          import("./components/statistics/qmark-dashboard/qmark-dashboard/qmark-dashboard.module").then(
            (m) => m.QmarkDashboardModule,
          ),
      },
      {
        path: "vendor-invitation",
        loadChildren: () =>
          import("./components/vendor-invitation/vendor-invitation-status/vendor-invitation-status.module").then(
            (m) => m.VendorInvitationStatusModule,
          ),
      },
      {
        path: "pim",
        loadChildren: () =>
          import("./components/pim/product-record/product-record.module").then(
            (m) => m.ProductRecordModule,
          ),
      },
      {
        path: "doccuementuploadhistory",
        loadChildren: () =>
          import("./components/pim/product-documents-upload-history/product-documents-upload-history.module").then(
            (m) => m.DocUploadHistoryModule,
          ),
      },
      {
        path: "LabDashboard",
        loadChildren: () =>
          import("./components/dashboards/dashboard/lab-dashboard.module").then(
            (m) => m.LabDashboardModule,
          ),
      },
      {
        path: "performance-analytics",
        loadChildren: () =>
          import("./components/dashboards/Performance Analytics/performance-analytics.module").then(
            (m) => m.PerformanceAnalyticsModule,
          ),
      },
      {
        path: "pim-product-dashBoard",
        loadChildren: () =>
          import("./components/pim/pim-product-dashboard/pim-product-dashboard.module").then(
            (m) => m.PimProductDashboardModule,
          ),
      },
      {
        path: "pim-product",
        loadChildren: () =>
          import("./components/pim/pim-product-summary/pimproductsummary.module").then(
            (m) => m.PimProductsummaryModule,
          ),
      },
      {
        path: "supplier",
        loadChildren: () =>
          import("./components/view-supplier-questionnaire/view-supplier-questionnaire.module").then(
            (m) => m.ViewSupplierQuestionnaireModule,
          ),
      },
      {
        path: "supplier-modelcode-list/:id",
        loadChildren: () =>
          import("./components/supplier-view-modelcode-list/supplier-view-modelcode-list.module").then(
            (m) => m.SupplierViewModelcodeListModule,
          ),
      },
      {
        path: "supplier-onboarding-stages/:id/:modelId",
        loadChildren: () =>
          import("./components/supplier-view-stages/supplier-view-stages.module").then(
            (m) => m.SupplierViewStagesModule,
          ),
      },
      {
        path: "supplier-onboarding-stages/:id/:modelId/:tabId",
        loadChildren: () =>
          import("./components/supplier-view-stages/supplier-view-stages.module").then(
            (m) => m.SupplierViewStagesModule,
          ),
      },
      {
        path: "pim-product",
        loadChildren: () =>
          import("./components/pim/pim-product-summary/pimproductsummary.module").then(
            (m) => m.PimProductsummaryModule,
          ),
      },
      {
        path: "settings/ProductSetting",
        loadChildren: () =>
          import("./components/admin/product-dept-settings/product-dept-settings.module").then(
            (m) => m.ProductDeptSettingsModule,
          ),
      },
      {
        path: "settings/SettingLandingDashboard",
        loadChildren: () =>
          import("./components/admin/setting-landing-page/setting-landing-page.module").then(
            (m) => m.SettingLandingPageModule,
          ),
      },
      {
        path: "settings/CareWordings",
        loadChildren: () =>
          import("./components/admin/care-wordings/care-wordings.module").then(
            (m) => m.CareWordingModule,
          ),
      },
      {
        path: "settings/ComponentTypes",
        loadChildren: () =>
          import("./components/admin/component-type/component-type.module").then(
            (m) => m.ComponentTypeModule,
          ),
      },

      {
        path: "settings/Contstructions",
        loadChildren: () =>
          import("./components/admin/construction-and-fabric-setting/construction-and-fabric-setting.module").then(
            (m) => m.ConstructionAndFabricSettingModule,
          ),
      },
      {
        path: "settings/CountryRegions",
        loadChildren: () =>
          import("./components/admin/countries/countries.module").then(
            (m) => m.CountriesModule,
          ),
      },
      {
        path: "settings/DesignDocumentLibrary",
        loadChildren: () =>
          import("./components/admin/document-library/document-library.module").then(
            (m) => m.DocumentLibraryModule,
          ),
      },
      {
        path: "departments",
        loadChildren: () =>
          import("./components/admin/departments/departments.module").then(
            (m) => m.DepartmentsModule,
          ),
      },

      {
        path: "labs",
        loadChildren: () =>
          import("./components/admin/lab-settings/lab-settings.module").then(
            (m) => m.LabSettingsModule,
          ),
      },

      {
        path: "lab/result-analytics",
        loadChildren: () =>
          import("./components/dashboards/result-analytics-dashboard/result-analytics-dashboard.module").then(
            (m) => m.ResultAnalyticsDashboardModule,
          ),
      },

      {
        path: "settings/MaterialSetting",
        loadChildren: () =>
          import("./components/admin/material-management/material-management.module").then(
            (m) => m.MaterialManagementModule,
          ),
      },
      {
        path: "settings/PortofDispatch",
        loadChildren: () =>
          import("./components/admin/port-of-dispatch/port-of-dispatch.module").then(
            (m) => m.PortOfDispatchModule,
          ),
      },
      {
        path: "settings/user-department",
        loadChildren: () =>
          import("./components/admin/user-department/user-department.module").then(
            (m) => m.UserDepartmentModule,
          ),
      },
      {
        path: "settings/Seasons",
        loadChildren: () =>
          import("./components/admin/sesons/sesons.module").then(
            (m) => m.SesonsModule,
          ),
      },
      {
        path: "settings/CareSymbols",
        loadChildren: () =>
          import("./components/admin/symbols/symbols.module").then(
            (m) => m.SymbolsModule,
          ),
      },
      {
        path: "supplier-profiles",
        loadChildren: () =>
          import("./components/admin/supplier-profiles/supplier-profiles.module").then(
            (m) => m.SupplierProfilesModule,
          ),
      },
      {
        path: "settings/Finishes",
        loadChildren: () =>
          import("./components/admin/finishes/finishes.module").then(
            (m) => m.FinishesModule,
          ),
      },
      {
        path: "settings/filetype",
        loadChildren: () =>
          import("./components/admin/file-type/file-type.module").then(
            (m) => m.FileTypeModule,
          ),
      },
      {
        path: "settings/ReadyToAssemble",
        loadChildren: () =>
          import("./components/admin/ready-to-assemble/ready-to-assemble.module").then(
            (m) => m.ReadyToAssembleModule,
          ),
      },
      {
        path: "settings/PreparationRoutes",
        loadChildren: () =>
          import("./components/admin/prepration-route/prepration-route.module").then(
            (m) => m.PreprationRouteModule,
          ),
      },
      {
        path: "settings/PackagingTypes",
        loadChildren: () =>
          import("./components/admin/packaging-type/packaging-type.module").then(
            (m) => m.PackagingTypeModule,
          ),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./components/admin/supplier-empowerment/supplier-empowerment.module").then(
            (m) => m.SupplierEmpowermentModule,
          ),
      },
      {
        path: "tcfTemplateEdit",
        loadChildren: () =>
          import("./components/tcfdata/tcf-template-edit/tcf-template-edit.module").then(
            (m) => m.TcfTemplateEditModule,
          ),
      },
      {
        path: "tcfTemplateSummary",
        loadChildren: () =>
          import("./components/tcfdata/tcf-template-summary/tcf-template-summary.module").then(
            (m) => m.TcfTemplateSummaryModule,
          ),
      },
      {
        path: "labbooking",
        loadChildren: () =>
          import("./components/Lab/lab-booking/lab-booking.module").then(
            (m) => m.LabBookingModule,
          ),
      },
      {
        path: "editlabbooking",
        loadChildren: () =>
          import("./components/Lab/edit-lab-booking/edit-lab-booking.module").then(
            (m) => m.EditLabBookingModule,
          ),
      },
      {
        path: "labbookingsummary",
        loadChildren: () =>
          import("./components/Lab/lab-booking-summary/lab-booking-summary.module").then(
            (m) => m.LabBookingSummaryModule,
          ),
      },
      {
        path: "tcfBooking",
        loadChildren: () =>
          import("./components/tcfdata/tcf-booking/tcf-booking.module").then(
            (m) => m.TcfBookingModule,
          ),
      },
      {
        path: "tcfdetailnew",
        loadChildren: () =>
          import("./components/tcfdata/tcf-detail-new/tcf-detail-new.module").then(
            (m) => m.TcfDetailNewModule,
          ),
      },
      {
        path: "tcfBookingSummary",
        loadChildren: () =>
          import("./components/tcfdata/tcf-booking-summary/tcf-booking-summary.module").then(
            (m) => m.TcfBookingSummaryModule,
          ),
      },
      {
        path: "tcfDocumentSummary",
        loadChildren: () =>
          import("./components/tcfdata/tcf-document-summary/tcf-document-summary.module").then(
            (m) => m.TcfDocumentSummaryModule,
          ),
      },
      {
        path: "tcfdashboardnew",
        loadChildren: () =>
          import("./components/tcfdata/tcf-dashboard-new/tcf-dashboard-new.module").then(
            (m) => m.TcfDashboardNewModule,
          ),
      },
      {
        path: "tcfconfiguration",
        loadChildren: () =>
          import("./components/tcfdata/tcf-configuration/tcf-configuration.module").then(
            (m) => m.TcfConfigurationModule,
          ),
      },
      {
        path: "tcf",
        loadChildren: () =>
          import("./components/tcfdata/supplier-score-new/supplier-score-new.module").then(
            (m) => m.SupplierScoreNewModule,
          ),
      },
      {
        path: "settings/PrintingMethods",
        loadChildren: () =>
          import("./components/admin/printing-method/printing-method.module").then(
            (m) => m.PrintingMethodModule,
          ),
      },
      {
        path: "settings/rss",
        loadChildren: () =>
          import("./components/admin/rss-settings/rss-settings.module").then(
            (m) => m.RssSettingsModule,
          ),
      },
      {
        path: "settings/Fibres",
        loadChildren: () =>
          import("./components/admin/fibers-settings/fibers-settings.module").then(
            (m) => m.FibersSettingsModule,
          ),
      },
      {
        path: "settings/species",
        loadChildren: () =>
          import("./components/admin/type-species-settings/type-species-settings.module").then(
            (m) => m.TypeSpeciesSettingsModule,
          ),
      },
      {
        path: "settings/DyeTypes",
        loadChildren: () =>
          import("./components/admin/dye-settings/dye-settings.module").then(
            (m) => m.DyeSettingsModule,
          ),
      },
      {
        path: "settings/PackagingExtendedMaterials",
        loadChildren: () =>
          import("./components/admin/packaging-and-extended-material/packaging-and-extended-material.module").then(
            (m) => m.PackagingAndExtendedMaterialModule,
          ),
      },
      {
        path: "TechnicalDrawingDescription",
        loadChildren: () =>
          import("./components/admin/discription-technical-drawing/discription-technical-drawing.module").then(
            (m) => m.DiscriptionTechnicalDrawingModule,
          ),
      },
      {
        path: "settings/ReasonForNewModelCode",
        loadChildren: () =>
          import("./components/admin/reason-model-code/reason-model-code.module").then(
            (m) => m.ReasonModelCodeModule,
          ),
      },
      {
        path: "settings/PackagingLevel",
        loadChildren: () =>
          import("./components/admin/packaging-level/packaging-level.module").then(
            (m) => m.PackagingLevelModule,
          ),
      },

      {
        path: "settings",
        loadChildren: () =>
          import("./components/admin/color/color.module").then(
            (m) => m.ColorModule,
          ),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./components/admin/art-house/art-house.module").then(
            (m) => m.ArtHouseModule,
          ),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./components/admin/photo-studio/photo-studio.module").then(
            (m) => m.PhotoStudioModule,
          ),
      },
      {
        path: "settings/PackagingCompostable",
        loadChildren: () =>
          import("./components/admin/packaging-compostable/packaging-compostable.module").then(
            (m) => m.PackagingCompostableModule,
          ),
      },
      {
        path: "settings/PackagingMaterialLamination",
        loadChildren: () =>
          import("./components/admin/packaging-material-lamination/packaging-material-lamination.module").then(
            (m) => m.PackagingMaterialLaminationModule,
          ),
      },
      {
        path: "settings/PackagingMaterialCoating",
        loadChildren: () =>
          import("./components/admin/packaging-material-coating/packaging-material-coating.module").then(
            (m) => m.PackagingMaterialCoatingModule,
          ),
      },
      {
        path: "settings/PackagingMethod",
        loadChildren: () =>
          import("./components/admin/packaging-method/packaging-method.module").then(
            (m) => m.PackagingMethodModule,
          ),
      },
      {
        path: "settings/PaperCareElements",
        loadChildren: () =>
          import("./components/admin/paper-card-element/paper-card-element.module").then(
            (m) => m.PaperCardElementModule,
          ),
      },
      {
        path: "settings/SeasonsLaunchMonth",
        loadChildren: () =>
          import("./components/admin/launch-phase-settings/launch-phase-settings.module").then(
            (m) => m.LaunchPhaseSettingsModule,
          ),
      },
      {
        path: "tcf",
        loadChildren: () =>
          import("./components/tcfdata/supplier-score-new/supplier-score-new.module").then(
            (m) => m.SupplierScoreNewModule,
          ),
      },

      {
        path: "lab/result-analytics",
        loadChildren: () =>
          import("./components/dashboards/result-analytics-dashboard/result-analytics-dashboard.module").then(
            (m) => m.ResultAnalyticsDashboardModule,
          ),
      },

      {
        path: "labbookingreport",
        loadChildren: () =>
          import("./components/Lab/lab-booking-report/lab-booking-report.module").then(
            (m) => m.LabBookingReportModule,
          ),
      },
      {
        path: "criteria-dashboard",
        loadChildren: () =>
          import("./components/dashboards/criteria-dashboard/criteria-dashboard.module").then(
            (m) => m.CriteriaDashboardModule,
          ),
      },
      {
        path: "settings/SizeRangeOption",
        loadChildren: () =>
          import("./components/admin/size-range-management/size-range-management.module").then(
            (m) => m.SizeRangeManagementModule,
          ),
      },
      {
        path: "mill-risk-summary",
        loadChildren: () =>
          import("./components/dashboards/mill-risk-summary/mill-risk-summary.module").then(
            (m) => m.MillRiskSummaryModule,
          ),
      },
      {
        path: "test-category",
        loadChildren: () =>
          import("./components/test-category/test-category.module").then(
            (m) => m.TestCategoryManagementModule,
          ),
      },
      // {
      {
        path: "dashboard",
        loadChildren: () =>
          import("./components/dashboards/test-category-dashboard/test-category-dashboard.module").then(
            (m) => m.TestCategoryDashboardModule,
          ),
      },
      {
        path: "lab/pass-rate-dashboard",
        loadChildren: () =>
          import("./components/Lab/lab-pass-rate-dashboard/lab-pass-rate-dashboard.module").then(
            (m) => m.LabPassRateDashboardModule,
          ),
      },

      {
        path: "master/risk_analysis_setting",
        loadChildren: () =>
          import("./components/master/risk-analysis-setting/risk-analysis-setting.module").then(
            (m) => m.RiskAnalysisSettingModule,
          ),
      },

      // {
      {
        path: "dashboard",
        loadChildren: () =>
          import("./components/dashboards/test-category-dashboard/test-category-dashboard.module").then(
            (m) => m.TestCategoryDashboardModule,
          ),
      },
      {
        path: "lab/pass-rate-dashboard",
        loadChildren: () =>
          import("./components/Lab/lab-pass-rate-dashboard/lab-pass-rate-dashboard.module").then(
            (m) => m.LabPassRateDashboardModule,
          ),
      },
      {
        path: "master",
        loadChildren: () =>
          import("./components/master/risk-analysis-setting/risk-analysis-setting.module").then(
            (m) => m.RiskAnalysisSettingModule,
          ),
      },
      {
        path: "master",
        loadChildren: () =>
          import("./components/master/risk-analysis-configration/risk-analysis-configration.module").then(
            (m) => m.RiskAnalysisConfigrationModule,
          ),
      },
      {
        path: "master",
        loadChildren: () =>
          import("./components/master/risk-analysis-configuration-summary/risk-analysis-configuration-summary.module").then(
            (m) => m.RiskAnalysisConfigurationSummaryModule,
          ),
      },
      {
        path: "risk-score-card",
        loadChildren: () =>
          import("./components/statistics/risk-score-card/risk-score-card.module").then(
            (m) => m.RiskScoreCardModule,
          ),
      },
      {
        path: "risk-score-card-dashboard",
        loadChildren: () =>
          import("./components/statistics/risk-score-card-dashboard/risk-score-card-dashboard.module").then(
            (m) => m.RiskScoreCardDashboardModule,
          ),
      },
      {
        path: "partnerconfig/parnter-configuration",
        loadChildren: () =>
          import("./components/partner-config/partner-configuration/partner-configuration.module").then(
            (m) => m.PartnerConfigurationModule,
          ),
      },
      {
        path: "booking_sysnc/lab_booking",
        loadChildren: () =>
          import("./components/Lab/lab-booking-sync/lab-booking-sync.module").then(
            (m) => m.LabBookingSyncModule,
          ),
      },
      // {
      //   path: ':forbidden',
      //   component : ForbiddenComponent
      // },
      // {
      //   path: ':page-not-found',
      //   component : ForbiddenComponent

      // }

      // },
      {
        path: "settings/ModelType",
        loadChildren: () =>
          import("./components/admin/model-type/model-type.module").then(
            (m) => m.ModelTypeModule,
          ),
      },
      {
        path: "settings/dd-courier",
        loadChildren: () =>
          import("./components/admin/dd-courier/dd-courier.module").then(
            (m) => m.DdCourierModule,
          ),
      },
      {
        path: "settings/ReturnAgreement",
        loadChildren: () =>
          import("./components/admin/return-agreement/return-agreement.module").then(
            (m) => m.ReturnAgreementModule,
          ),
      },
      {
        path: "settings/InvoiceType",
        loadChildren: () =>
          import("./components/admin/invoice-type/invoice-type.module").then(
            (m) => m.InvoiceTypeModule,
          ),
      },
      {
        path: "settings/Teams",
        loadChildren: () =>
          import("./components/admin/teams/teams.module").then(
            (m) => m.TeamsModule,
          ),
      },
      {
        path: "settings/PaymentTerms",
        loadChildren: () =>
          import("./components/admin/payment-terms/payment-terms.module").then(
            (m) => m.PaymentTermsModule,
          ),
      },
      {
        path: "settings/position-master",
        loadChildren: () =>
          import("./components/admin/position/position.module").then(
            (m) => m.PositionModule,
          ),
      },
      {
        path: "settings/component-supplier",
        loadChildren: () =>
          import("./components/admin/component-supplier/component-supplier.module").then(
            (m) => m.ComponentSupplierModule,
          ),
      },
      {
        path: "settings/DocumentSettings",
        loadChildren: () =>
          import("./components/admin/document-settings/document-settings.module").then(
            (m) => m.DocumentSettingsModule,
          ),
      },
      {
        path: "product-tag",
        loadChildren: () =>
          import("./components/admin/product-tag/product-tag.module").then(
            (m) => m.ProductTagModule,
          ),
      },
      // {
      //   path: "settings/producttypestatus",
      //   loadChildren: () => import(
      //       "./components/admin/internet-product-type/internet-product-type.module"
      //     ).then((m) => m.InternetProductTypeModule),
      // },
      {
        path: "settings/producttypestatus",
        loadChildren: () =>
          import("./components/admin/internet-product-type/internet-product-type.module").then(
            (m) => m.InternetProductTypeModule,
          ),
      },
      {
        path: "settings/BulkImport",
        loadChildren: () =>
          import("./components/admin/bulk-import/bulk-import.module").then(
            (m) => m.BulkImportModule,
          ),
      },
      {
        path: "BulkExport",
        loadChildren: () =>
          import("./components/admin/bulk-export/bulk-export.module").then(
            (m) => m.BulkExportModule,
          ),
      },
      {
        path: "settings/bulk-transfer",
        loadChildren: () =>
          import("./components/admin/bulk-transfer/bulk-transfer.module").then(
            (m) => m.BulkTransferModule,
          ),
      },
      {
        path: "AssessmentMaster",
        loadChildren: () =>
          import("./components/admin/plm-settings/plm-settings.module").then(
            (m) => m.PlmSettingsModule,
          ),
      },
      {
        path: "admin/import-history",
        loadChildren: () =>
          import("./components/admin/import-history/import-history.module").then(
            (m) => m.ImportHistoryModule,
          ),
      },
      {
        path: "notification-settings",
        loadChildren: () =>
          import("./components/admin/notification-settings/notification-settings.module").then(
            (m) => m.NotificationSettingsModule,
          ),
      },
      {
        path: "constructions",
        loadChildren: () =>
          import("./components/admin/constructions/constructions.module").then(
            (m) => m.ConstructionsModule,
          ),
      },
      // {
      //   path: "settings/FabricTypes",
      //   loadChildren: () =>
      //     import("./components/admin/construction-and-fabric-setting/fabric/fabric.module").then(
      //       (m) => m.FabricModule
      //     ),
      // },
      {
        path: "settings/Signoff",
        loadChildren: () =>
          import("./components/admin/signoff-stage-master/signoff-stage-master.module").then(
            (m) => m.SignoffStageMasterModule,
          ),
      },
      {
        path: "settings/BDCMCategory",
        loadChildren: () =>
          import("./components/admin/bdmc-category/bdmc-category.module").then(
            (m) => m.BdmcCategoryModule,
          ),
      },
      {
        path: "settings/TeamsAndUser",
        loadChildren: () =>
          import("./components/admin/team-and-user/team-and-user.module").then(
            (m) => m.TeamAndUserModule,
          ),
      },
      {
        path: "settings/user-department",
        loadChildren: () =>
          import("./components/admin/user-department/user-department.module").then(
            (m) => m.UserDepartmentModule,
          ),
      },
      {
        path: "settings/TransitPackagingMethod",
        loadChildren: () =>
          import("./components/admin/transit-packaging-method/transit-packaging-method.module").then(
            (m) => m.TransitPackagingMethodModule,
          ),
      },
      {
        path: "settings/PackagingLayer",
        loadChildren: () =>
          import("./components/admin/packaging-layer/packaging-layer.module").then(
            (m) => m.PackagingLayerModule,
          ),
      },
      {
        path: "settings/OPRLlabelMassage",
        loadChildren: () =>
          import("./components/admin/oprl-label-massage/oprl-label-massage.module").then(
            (m) => m.OPRLLabelMassageModule,
          ),
      },
      {
        path: "settings/EntriesList",
        loadChildren: () =>
          import("./components/admin/critical-path-setting/critical-path-setting.module").then(
            (m) => m.CriticalPathSettingModule,
          ),
      },
      {
        path: "product-lifecycle",
        loadChildren: () =>
          import("./components/product-lifecycle-management/plm-landing-dashboard/plm-landing-dashboard.module").then(
            (m) => m.PlmLandingDashboardModule,
          ),
      },
      {
        path: "plmlandingdashboard",
        loadChildren: () =>
          import("./components/product-lifecycle-management/plm-dashboard/plm-dashboard.module").then(
            (m) => m.PlmDashboardModule,
          ),
      },
      {
        path: "create-design",
        loadChildren: () =>
          import("./components/product-lifecycle-management/create-new-design/create-new-design.module").then(
            (m) => m.CreateNewDesignModule,
          ),
      },
      {
        path: "design-details",
        loadChildren: () =>
          import("./components/product-lifecycle-management/design-details/design-details.module").then(
            (m) => m.DesignDetailsModule,
          ),
      },
      {
        path: "design-status",
        loadChildren: () =>
          import("./components/product-lifecycle-management/design-status/design-status.module").then(
            (m) => m.DesignStatusModule,
          ),
      },
      {
        path: "user-type",
        loadChildren: () =>
          import("./components/admin/user-type-configuration/user-type-configuration.module").then(
            (m) => m.UserTypeConfigurationModule,
          ),
      },
      {
        path: "supplier-management",
        loadChildren: () =>
          import("./components/supplier-management/supplier-management.module").then(
            (m) => m.SupplierManagementModule,
          ),
      },
      {
        path: "settings",
        loadChildren: () =>
          import("./components/admin/document-library-master/document-library-master.module").then(
            (m) => m.DocumentLibraryMasterModule,
          ),
      },
      {
        path: "settings/range",
        loadChildren: () =>
          import("./components/admin/range/range.module").then(
            (m) => m.RangeModule,
          ),
      },
      {
        path: "manage-approve",
        loadChildren: () =>
          import("./components/admin/manage-approved-component/manage-approved-component.module").then(
            (m) => m.ManageApprovedComponentModule,
          ),
      },

      {
        path: "HipsRoleReplyConfig/hips-role-reply-config",
        loadChildren: () =>
          import("./components/admin/hips-role-reply-config/hips-role-reply-config.module").then(
            (m) => m.HipsRoleReplyConfigModule,
          ),
      },
      // /supplier-details/:id/:parentId
    ],
  },
  {
    path: "vendor-lite",
    loadChildren: () =>
      import("./components/vendor-invitation/add-invited-vendor/add-invited-vendor.module").then(
        (m) => m.AddInvitedVendorModule,
      ),
  },
  {
    path: "shared",
    loadChildren: () =>
      import("./components/shared/shared.module").then((m) => m.SharedModule),
  },
  {
    path: "resetpassword",
    loadChildren: () =>
      import("./components/change-password/changepassword.module").then(
        (m) => m.ChangepasswordModule,
      ),
  },
  {
    path: "changepassword",
    loadChildren: () =>
      import("./components/change-password/changepassword.module").then(
        (m) => m.ChangepasswordModule,
      ),
  },
  {
    path: "emailuserverification",
    loadChildren: () =>
      import("./components/login/emailuser-verification/emailuser-verification.module").then(
        (m) => m.EmailUserVerificationModule,
      ),
  },
  {
    path: "supplier-invite/:id",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./components/supplier-invitation/supplier-invitation.module").then(
        (m) => m.SupplierInvitationModule,
      ),
  },
  {
    path: "supplier-questionnaire/:id",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./components/supplier-questionnaire/supplier-questionnaire.module").then(
        (m) => m.SupplierQuestionnaireModule,
      ),
  },

  //{
  //  path: 'resetpassword',
  //  loadChildren: () => import('./components/change-password/changepassword.module').then(m => m.ChangepasswordModule)
  //},
  //{
  //  path: 'changepassword',
  //  loadChildren: () => import('./components/change-password/changepassword.module').then(m => m.ChangepasswordModule)
  //},
  {
    path: "shared",
    loadChildren: () =>
      import("./components/shared/shared.module").then((m) => m.SharedModule),
  },
  {
    path: "resetpassword",
    loadChildren: () =>
      import("./components/change-password/changepassword.module").then(
        (m) => m.ChangepasswordModule,
      ),
  },
  {
    path: "changepassword",
    loadChildren: () =>
      import("./components/change-password/changepassword.module").then(
        (m) => m.ChangepasswordModule,
      ),
  },
  {
    path: "emailuserverification",
    loadChildren: () =>
      import("./components/login/emailuser-verification/emailuser-verification.module").then(
        (m) => m.EmailUserVerificationModule,
      ),
  },
  {
    path: "landing",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./components/landing/landing.module").then(
        (m) => m.LandingModule,
      ),
  },
  {
    path: "callback",
    loadChildren: () =>
      import("./components/login/callback/callback.module").then(
        (m) => m.CallbackModule,
      ),
  },
  {
    path: "error/401",
    component: UnauthorizedComponent,
  },
  // {
  //   path: "**",
  //   pathMatch: "full",
  //   component: ForbiddenComponent,
  // },
  {
    path: "refresh-token",
    loadChildren: () =>
      import("./components/login/refresh-token/refresh-token.module").then(
        (m) => m.RefreshTokenModule,
      ),
  },

  {
    path: "error/401",
    component: UnauthorizedComponent,
  },
  {
    path: "error/409",
    component: ConflictComponent,
  },
  {
    path: "**",
    pathMatch: "full",
    component: ForbiddenComponent,
  },
];

export const routing = RouterModule.forRoot(appRoutes, {});
